console.log('Vite ⚡️ Rails');
console.log("application.js is loading...");

// Import libraries
import $ from 'jquery';
import 'jquery-ui';
import 'bootstrap';
import '@popperjs/core';

import 'popper-scrollto-override';
import 'select2-init';
import 'select2_simple_form';


import { Application } from '@hotwired/stimulus';
// "@hotwired/stimulus-loading": "^0.2.1"

// Import custom controllers
import '../controllers';

// Import custom functions
import '../functions/drag_n_drop_questions';
import '../functions/drag_n_drop_properties';
import { initializeExpandableBoxes } from '../functions/expandable_boxes';
import { searchBoxesInputs } from '../functions/searchable_field_utils/search_boxes_inputs';
import { toggleExpandableBox } from '../functions/searchable_field_utils/search_boxes_box';
import { clearSearchBoxes, redirectSearchBoxes } from '../functions/searchable_fields';
import { toggleAllSections } from '../functions/toggle_all_sections';
import { toggleSection } from '../functions/toggle_section';
import { createDandelion } from '../functions/dandelion-background';


// Import Hotwired libraries
import { Turbo } from "@hotwired/turbo-rails";
Turbo.start();
// Import ujs (so the data confirm will work again)
import Rails from "@rails/ujs";
Rails.start();


// Initialize functions and event listeners
document.addEventListener('turbo:load', () => {
    initializeExpandableBoxes();
    searchBoxesInputs();

    const colors = ['#A2CCB6', '#FCEEB5', '#EE786E', '#e0feff', 'lightpink', '#c7c5f4'];
    createDandelion(200, colors);

    const expandableBox = document.querySelector('.expandable-box');
    if (expandableBox) {
        expandableBox.addEventListener('click', toggleExpandableBox);
    }

    const toggleAllButton = document.querySelector('.btn-toggle-all');
    if (toggleAllButton) {
        toggleAllButton.addEventListener('click', toggleAllSections);
    }
});

document.addEventListener('click', (event) => {
    if (event.target instanceof HTMLElement) {
        if (event.target.classList.contains('clear-search-button')) {
            event.preventDefault();
            clearSearchBoxes();
            const form = document.querySelector('.festi-form-inline-row');
            form?.reset();
        }

        if (event.target.classList.contains('festi-search-button')) {
            event.preventDefault();
            redirectSearchBoxes();
        }
    }
});

console.log("application.js is loaded");
